import { ACTION_GIFTCODE_CLAIM, ACTION_GIFTCODE_CLAIM_ERROR, ACTION_GIFTCODE_CLAIM_SUCCESS } from "."
import * as api from "../../../api"
import * as authActions from "../../auth/actions";

export const giftCodeClaimRequest = (access_token, code, url) => ({
    type: ACTION_GIFTCODE_CLAIM,
    payload: {
        access_token,
        code,
        url
    }
})

export const giftCodeClaimSuccess = data => ({
    type: ACTION_GIFTCODE_CLAIM_SUCCESS,
    payload: { ...data }
})


export const giftCodeClaimError = (msg) => ({
    type: ACTION_GIFTCODE_CLAIM_ERROR,
    payload: {
        msg
    }
})

export const giftCodeClaim = (access_token, code, url) => {
    return dispatch => {
        dispatch(giftCodeClaimRequest(access_token, code, url))
        api.giftCodeClaim(access_token, code, url)
            .then(({ data }) => {
                if (data.result.code !== 0) {
                    dispatch(giftCodeClaimError("error"));
                    return
                }

                dispatch(giftCodeClaimSuccess({chip: data.chip, msg: data.result.message}));
            }).catch((err) => {

                console.log(err)

                if (err.response) {
                    if (err.response.status === 401) {
                        dispatch(authActions.logout())
                        return
                    }
                }

                dispatch(giftCodeClaimError("system error"))
            });
    }
}